import { memo, ReactNode, SyntheticEvent, useContext } from 'react'
import { Box } from '@stoplight/mosaic'

import {
  getHtmlIdFromItemId,
  TableOfContentsNodeGroup,
  TableOfContentsNode as Node,
} from './index'
import { ActiveIdContext, LinkContext } from './TableOfContents'
import { TableOfContentsItem } from './TableOfContentsItem'

type TableOfContentsNodeProps = {
  item: Node | TableOfContentsNodeGroup
  depth: number
  meta?: ReactNode
  onClick?: (e: SyntheticEvent, forceOpen: boolean) => void
  onLinkClick?: () => void
}

export const TableOfContentsNode = memo<TableOfContentsNodeProps>(
  ({ item, depth, meta, onClick, onLinkClick }) => {
    const activeId = useContext(ActiveIdContext)
    const isActive = activeId === item.id
    const LinkComponent = useContext(LinkContext)

    const handleClick = (e: SyntheticEvent) => {
      if (isActive) {
        // Don't trigger link click when we're active
        e.stopPropagation()
        e.preventDefault()
      } else {
        onLinkClick && onLinkClick()
      }

      // Force open when clicking inactive group
      if (onClick) {
        onClick(e, isActive)
      }
    }

    return (
      <Box
        as={LinkComponent}
        to={item.slug}
        display="block"
        textDecoration="no-underline"
        className="ElementsTableOfContentsItem"
      >
        <TableOfContentsItem
          id={getHtmlIdFromItemId(item.id)}
          isActive={isActive}
          depth={depth}
          title={item.title}
          meta={meta}
          onClick={handleClick}
        />
      </Box>
    )
  }
)
